
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/root",
      function () {
        return require("private-next-pages/root/index.route.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/root"])
      });
    }
  